import { connectStateResults } from 'react-instantsearch-dom';
import CustomHits from 'components/search/productSearch/hits';
import styles from './productStateResults.module.scss';

const StateResults = ({ locale, searchResults, searchState, globals }) => {
  const { results } = globals[0];
  const { productsTitle, noProducts } = globals[3];

  const numberOfProducts = searchResults && searchResults.nbHits;
  const hasFoundProducts = searchResults && searchResults.nbHits !== 0 && searchState.query;
  const zeroProducts =
    searchResults && searchResults.nbHits === 0 && searchState.query && searchState.query !== '';
  const noSearchDone = !searchState.query;

  return (
    <>
      <div className={styles.stateResultsWrapper}>
        {!noSearchDone && (
          <>
            <h3 className={styles.resultsText}>
              {productsTitle.text} ({numberOfProducts} {results.text})
            </h3>
            {zeroProducts && (
              <p className={styles.noResultsText}>
                {noProducts.text} {searchState.query}
              </p>
            )}
          </>
        )}
        {hasFoundProducts && (
          <>
            <CustomHits locale={locale} searchQuery={searchState.query} globals={globals} />
          </>
        )}
      </div>
    </>
  );
};

const CustomProductStateResults = connectStateResults(StateResults);

export default CustomProductStateResults;
